import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d876f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification-bar"
}

import { useNotificationStore } from "@/store/notification-store";

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBar',
  setup(__props) {

const notificationStore = useNotificationStore();

return (_ctx: any,_cache: any) => {
  return (_unref(notificationStore).notifications.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationStore).notifications, (notification, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(notification), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})